// extracted by mini-css-extract-plugin
export default {"cardList":"WhyChooseUsList_cardList__egRmo"};